module.exports = __webpack_public_path__ + "img/hef_alith_anar_0.b0690be0.png";